import React from 'react';

const Provider = (props) => (
    <li key={props.provider.id}>
        <a
            className="icon-font-after icon-external-outline-after"
            onClick={(event) => { event.preventDefault(); return props.providerSelect(props.provider); }}
        >
            {props.provider.name}
        </a>
    </li>
);

Provider.propTypes = {
    provider: React.PropTypes.object,
    providerSelect: React.PropTypes.func
};

export default Provider;



// WEBPACK FOOTER //
// ./app/modal/authn/Provider.js